<template>
  <v-row>
    <v-col cols="12" md="6">
      <gg-card-title class="pb-0 pt-0">{{ $route.meta.pageTitle }}</gg-card-title>
    </v-col>
    <v-col cols="12" md="6" class="text-md-right pb-2">
      <gg-btn tile color="primary" class="mt-1" :to="{ name: 'hosting_kvm_order' }">
        Add Server
      </gg-btn>
    </v-col>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          <v-row>
            <v-col md="6">
              My Servers
            </v-col>
            <v-col md="6" class="d-flex flex-sm-row flex-column justify-end align-start gap-sm align-md-center">
              <div class="w-100" style="max-width: 440px">
                <services-search v-model="search" compact />
              </div>
            </v-col>
          </v-row>
        </gg-card-header>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="rows"
            :search="search"
            :footer-props="{ itemsPerPageOptions: pagination }"
            no-data-text="You don't have any servers yet."
            sort-by="displayName"
          >
            <template v-slot:item.displayName="{ item }">
              <div>
                <router-link :to="manageRoute(item)" class="ggs-item-title">
                  {{ item.displayName }}
                </router-link>
                <template v-if="item.domain && item.name">
                  <br>
                  <span class="caption">{{ item.name }}</span>
                </template>
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <v-icon small class="pb-1" :color="statusColor(item.status)">mdi-circle</v-icon>
              <span class="pl-1">{{ item.status }}</span>
            </template>
            <template v-slot:item.groupname="{ item }">
              {{ item.groupname || '—' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <gg-btn class="mr-1" :to="manageRoute(item)">
                Manage
              </gg-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import kvm from '@/api/kvm'
import { statusColor } from '@/helpers/helpers'
import { SERVICE_TYPES } from '@/consts/service'
import ServicesSearch from 'Components/Services/Hosting/ServicesPage/ServicesSearch'

export default {
  name: 'HostingKvmList',
  components: {
    ServicesSearch,
  },
  data: () => ({
    // KVM service id → the customer's label for it (Prox, not billing); filled
    // in the background so the list never waits on it.
    labels: {},
    search: '',
    headers: [
      { text: 'Service', value: 'displayName' },
      { text: 'Service Type', value: 'groupname' },
      { text: 'Status', value: 'status' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  computed: {
    ...mapGetters(['services', 'pagination']),
    // All the account's servers, straight from the shared service list (billing):
    // the KVM product (/servers/vps/:id) and the existing VPS product (/servers/mvm/:id).
    servers () {
      return (this.services || []).filter(s => s.type === SERVICE_TYPES.KVM || s.type === SERVICE_TYPES.VPS)
    },
    // The servers with the name shown in the table, so it sorts and searches too.
    rows () {
      return this.servers.map(s => ({ ...s, displayName: this.displayName(s) }))
    },
  },
  watch: {
    servers: { immediate: true, handler () { this.loadLabels() } },
  },
  methods: {
    statusColor,
    // The customer's label when they set one, else the billing name.
    displayName (server) {
      return this.labels[server.id] || server.domain || server.name
    },
    loadLabels () {
      for (const s of this.servers) {
        if (s.type !== SERVICE_TYPES.KVM || s.id in this.labels) continue
        this.$set(this.labels, s.id, null)
        kvm.getService(s.id)
          .then(svc => { this.$set(this.labels, s.id, (svc && svc.label) || null) })
          .catch(() => { /* not provisioned / unreachable: keep the billing name */ })
      }
    },
    manageRoute (server) {
      return server.type === SERVICE_TYPES.KVM
        ? { name: 'hosting_kvm_info', params: { hostingid: server.id } }
        : { name: 'hosting_vserver_info', params: { hostingid: server.id } }
    },
  },
}
</script>
